import { render, staticRenderFns } from "./dingQrLogin.vue?vue&type=template&id=b55279c8&"
import script from "./dingQrLogin.vue?vue&type=script&lang=js&"
export * from "./dingQrLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports